<template>
  <b-container class="landing">
    <section>
      <b-row>
        <b-col class="text-center" cols="12">
          <h2>Fingers Meet</h2>
          <div class="subtitle">
            Try getting a chat chance!
          </div>
        </b-col>
      </b-row>
    </section>
    <section class="mt-5">
      <b-row>
        <b-col class="text-center">
          <p class="mb-1">
            Fingers Meet is a simple social-network game.
          </p>
          <p class="mb-1">
            A chat chance will be a reward if a pair of players' screen touches
            getting close enough. Have fun!
          </p>
        </b-col>
      </b-row>
    </section>
    <section class="mt-5">
      <b-row>
        <b-col class="text-center" cols="12">
          <h3>Downloads</h3>
          <hr />
        </b-col>
      </b-row>
      <b-row
        class="d-flex justify-content-center"
        align-v="center"
        align-h="center"
        align-content="center"
      >
        <b-col class="d-flex justify-content-center" cols="12" md="6" lg="3">
          <a href="https://apps.apple.com/us/app/fingers-meet/id1533383508"
            ><img
              class="badge-img"
              src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-US?size=250x83&amp;releaseDate=1597363200&h=87768b81c6c4415cb1b7e3fd317a0ce8"
              alt="Download on the App Store"
              style="border-radius: 13px; width: 250px; padding: 18px 18px;"
          /></a>
        </b-col>
        <b-col class="d-flex justify-content-center" cols="12" md="6" lg="3">
          <a
            href="https://play.google.com/store/apps/details?id=com.codevalop.fingersmeet"
            ><img
              class="badge-img"
              src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
              alt="Get it on Google Play"
              style="border-radius: 13px; width: 250px;"
          /></a>
        </b-col>
      </b-row>
    </section>
  </b-container>
</template>

<script>
  export default {
    name: "Landing",
    metaInfo: {
      title: "Welcome",
    },
    data: function() {
      return {};
    },
    mounted: function() {},
    methods: {},
  };
</script>

<style scoped>
  @import "~css/landing.css";
</style>
